export interface MainCreditStatusData {
  trueStatus: string,
  leasingCompany: any,
  approvalNumber: string,
  specialNotes: string,
}

export interface MasterSelectData {
  label: string,
  name: string,
  isReadOnly: boolean,
  value: string,
}

export const MainCreditStatusData: MainCreditStatusData = {
  trueStatus: '確認中',
  leasingCompany: '',
  approvalNumber: '',
  specialNotes: '',
}

export const LeasingCompanyOutputData: Array<{ [key: string]: any }> = [
  { label: '', name: 'leasing_company', isDisabled: true, value: '' },
  { label: '', name: 'telephone_number', isDisabled: true, value: '' }
]
